import { SvgIconNames } from '@toggle/design-system';

export const getCatalystInsightIconProps = ({
  isBordered,
  isCompanyCatalyst,
  isDisabled,
  isRead,
}: {
  isBordered: boolean;
  isCompanyCatalyst?: boolean;
  isDisabled?: boolean;
  isRead?: boolean;
}): {
  iconName: SvgIconNames;
  viewBox: string;
  fillColor?: string;
} => {
  if (isBordered) {
    return {
      iconName: isCompanyCatalyst ? 'PuzzleLime' : 'PuzzleCyan',
      viewBox: '0 0 34 40',
    };
  }

  const fillColor = isCompanyCatalyst
    ? 'var(--icon-decorative-lime)'
    : 'var(--icon-decorative-cyan)';

  return {
    iconName: 'PuzzleBorderless',
    viewBox: '0 0 12 12',
    fillColor: isDisabled || isRead ? 'var(--icon-soft)' : fillColor,
  };
};
